import { Action, createReducer } from "@ngrx/store";
import { initialUsuarioState, IUsuarioState } from "./usuario.state";

const reducer = createReducer(
	initialUsuarioState,
 
);

export function usuarioReducer(
  state: IUsuarioState = initialUsuarioState,
  action: Action
): IUsuarioState {
  return reducer(state, action);
}
